import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import data from "./data.json";

const Table = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  let tableBodyArray = [];
  let tableBody = "";
  for (let i = 0; i < 14; i++) {
    tableBody = (
      <tr key={i}>
        <td className="p-5 text-bodyColor text-lg font-Outfit font-normal break-words">
          {/* {data.person1.User} */}
        </td>
        <td className="p-5 text-bodyColor text-lg font-Outfit font-semibold break-words">
          {/* {data.person1.Profile} */}
        </td>
        <td className="p-5">
          {/* <button className="rounded-full bg-tableColor w-10 h-10"></button> */}
        </td>
        <td className="p-5 text-bodyColor text-lg font-Outfit font-semibold break-words">
          {/* {data.person1.BorrowedValue} */}
        </td>
        <td className="p-5">
          {/* <button className="rounded-full bg-tableColor w-10 h-10"></button> */}
        </td>
        <td className="p-5 text-bodyColor text-lg font-Outfit font-semibold break-words">
          {/* {data.person1.DepositedAsset} */}
        </td>
        <td className="p-5 text-riskColor text-base font-Outfit font-semibold break-words">
          {/* {data.person1.RiskFactor} */}
        </td>
        <td className="p-5">
          {/* <button
                type="button"
                className="bg-submitButtonColor px-6 py-3 text-white text-sm font-Outfit font-semibold break-words rounded-lg"
              >
                Liquidate
              </button> */}
        </td>
      </tr>
    );
    tableBodyArray.push(tableBody);
  }
  return (
    <div className="overflow-x-auto mx-auto w-11/12 mt-14 shadow-md shadow-tableColor rounded-lg">
      <table className="w-full text-center text-sm font-light">
        <thead className="font-medium bg-tableColor">
          <tr>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              User
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              Profile
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              Borrowed Asset(s)
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              <span className="flex items-center justify-center">
                Borrowed Value
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                  />
                </svg>
              </span>
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              Deposited Asset(s)
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              <span className="flex items-center justify-center">
                Deposited Asset(s)
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                  />
                </svg>
              </span>
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              Risk Factor
            </th>
            <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
              Operation
            </th>
          </tr>
        </thead>
        <tbody className="bg-tableBodyColor">
          <tr>
            <td className="p-5 text-bodyColor text-lg font-Outfit font-normal break-words">
              {data.person1.User}
            </td>
            <td className="p-5 text-bodyColor text-lg font-Outfit font-semibold break-words">
              {data.person1.Profile}
            </td>
            <td className="p-5">
              <button className="rounded-full bg-tableColor w-10 h-10"></button>
            </td>
            <td className="p-5 text-bodyColor text-lg font-Outfit font-semibold break-words">
              {data.person1.BorrowedValue}
            </td>
            <td className="p-5">
              <button className="rounded-full bg-tableColor w-10 h-10"></button>
            </td>
            <td className="p-5 text-bodyColor text-lg font-Outfit font-semibold break-words">
              {data.person1.DepositedAsset}
            </td>
            <td className="p-5 text-riskColor text-base font-Outfit font-semibold break-words">
              {data.person1.RiskFactor}
            </td>
            <td className="p-5">
              <button
                type="button"
                className="bg-submitButtonColor px-6 py-3 text-white text-sm font-Outfit font-semibold break-words rounded-lg"
                onClick={openModal}
              >
                Liquidate
              </button>
            </td>
          </tr>
          {tableBodyArray}
        </tbody>
      </table>

      {/* Liquidate Modal */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-backdropBlurColor backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-modalWidth transform overflow-hidden rounded-lg bg-tableBodyColor text-left align-middle shadow-xl transition-all">
                  {/* Modal Title */}
                  <Dialog.Title
                    as="div"
                    className="w-full h-modalHeight flex justify-between items-center bg-tableColor p-7 text-bodyColor font-Inter text-2xl not-italic font-bold leading-normal"
                  >
                    Liquidate
                    <button type="button" onClick={closeModal}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </Dialog.Title>

                  {/* Modal Body */}
                  <div className="pt-12 px-7">
                    <div className="flex justify-between items-center">
                      <div className="text-bodyColor font-Inter text-2xl not-italic font-medium leading-normal">
                        You Pay
                      </div>
                      <div className="text-opaBodyColor text-right font-Inter text-base not-italic font-medium leading-normal">
                        Needless repay will return to your wallet
                      </div>
                    </div>
                    <div className="p-6 mt-5 flex justify-between items-center border border-opaBorderColor border-solid rounded-lg">
                      <div className="flex items-center">
                        <div className="rounded-full bg-tableColor w-10 h-10"></div>
                        <div className="flex items-center pl-2">
                          <label
                            htmlFor="info_1"
                            className="block text-sm font-medium leading-6 text-gray-900"
                          ></label>
                          <select
                            id="info_1"
                            name="info_1"
                            className="flex items-center w-20 rounded-md border-0 bg-tableBodyColor focus:outline-none text-bodyColor text-center font-Inter text-2xl not-italic font-medium leading-normal"
                            defaultValue="BTC"
                          >
                            <option className="bg-white">BTC</option>
                          </select>
                        </div>
                        <div className="pl-16 text-bodyColor text-center font-Inter text-liquidateModal not-italic font-medium leading-normal">
                          0
                        </div>
                      </div>
                      <div className="text-opaBodyColor text-right font-Inter text-base not-italic font-medium leading-normal">
                        $0.00
                      </div>
                    </div>
                    <div className="flex justify-between items-center mt-4">
                      <div className="text-opaBodyColor font-Inter text-base not-italic font-medium leading-normal">
                        Wallet: 4.124121 APT
                      </div>
                      <button className="px-3 py-2 bg-submitButtonColor text-white rounded-lg">
                        max
                      </button>
                    </div>
                    <div className="pt-10 text-bodyColor font-Inter text-2xl not-italic font-medium leading-normal">
                      Gain up to
                    </div>
                    <div className="p-6 mt-6 flex justify-between items-center border border-opaBorderColor border-solid rounded-lg">
                      <div className="flex items-center">
                        <div className="rounded-full bg-tableColor w-10 h-10"></div>
                        <div className="flex items-center pl-2">
                          <label
                            htmlFor="info_2"
                            className="block text-sm font-medium leading-6 text-gray-900"
                          ></label>
                          <select
                            id="info_2"
                            name="info_2"
                            className="flex items-center w-20 rounded-md border-0 bg-tableBodyColor focus:outline-none text-bodyColor text-center font-Inter text-2xl not-italic font-medium leading-normal"
                            defaultValue="BTC"
                          >
                            <option>BTC</option>
                          </select>
                        </div>
                        <div className="pl-16 text-bodyColor text-center font-Inter text-liquidateModal not-italic font-medium leading-normal">
                          1.64532
                        </div>
                      </div>
                      <div className="text-opaBodyColor text-right font-Inter text-base not-italic font-medium leading-normal">
                        $0.00
                      </div>
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="p-7">
                    <button
                      type="button"
                      className="inline-flex justify-center items-center w-full h-modalButtonHeight py-4 bg-submitButtonColor text-white rounded-lg text-center font-Inter text-lg not-italic font-semibold leading-normal"
                      onClick={closeModal}
                    >
                      Repay
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default Table;
